<!--
 * @ Author: Your name
 * @ Create Time: 2019-05-25 10:25:38
 * @ Modified by: Your name
 * @ Modified time: 2019-08-07 14:42:31
 * @ Description: 角色管理
 -->

<template>
  <div class="content-wrapper">
    <div class="tool-bar">
      <el-button type="danger" size="small" icon="el-icon-plus"
        @click="handleBtn('add')">新增</el-button>
      <el-button type="warning" size="small" icon="el-icon-edit"
        @click="handleBtn('edit')">修改</el-button>
      <el-button type="info" size="small" icon="el-icon-delete"
        @click="handleBtn('del')">删除</el-button>
      <el-button class="disabled" size="small" icon="el-icon-refresh-right"
       @click="handleBtn('forbbiden')">禁用</el-button>
      <el-button type="success" size="small" icon="el-icon-refresh-left"
       @click="handleBtn('unforbbiden')">反禁用</el-button>
    </div>
    <table-pagination
      ref="table"
      :tableData="tableData"
      :height='500'
      service
      :loading='tableLoading'
      :isRoleManage='isRoleManage'
      @service-fn="handleService"
      @row-click="rowClick">
      <!-- <el-table-column type="selection" width="50" align="center" /> -->
      <el-table-column label="" width="45" align="center">
        <template slot-scope="scope">
          <el-radio class="radio" v-model="tableRadio" :label="scope.$index">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column prop="roleName" label="角色名" align="center" width="200">
        <template slot-scope="scope">
          {{scope.row.roleName.split(',')[0]}}
        </template>
      </el-table-column>
      <el-table-column prop="menuName" label="权限列表" align="left" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-for="(item, index) in scope.row.menuName"
            :key='index'>{{item.split(',')[0]}}
            <span v-if="index !== scope.row.menuName.length - 1">、</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="禁用状态" prop="roleName" align="center" width="200">
        <template slot-scope="scope">
          {{formatForbbiden(scope.row.roleName.split(',')[2])}}
        </template>
      </el-table-column>
    </table-pagination>
    <!-- 这是按钮的提示弹窗 -->
    <dialog-tip :handleDialogVisible='handleDialogVisible' :handleBtnTip='handleBtnTip'
      @handleDialogComfirm='handleDialogComfirm'
      @handleDialogClose='handleDialogClose'></dialog-tip>
    <!-- 这是新增、修改 按钮打开的弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="mainDialogVisible"
      width="650px"
      >
      <dialog-main ref="dialogForm"
        :type="type"
        :id="dialogId"
        :visible='mainDialogVisible'
        :dic='dic'>
      </dialog-main>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mainDialogVisible = false" size="small" type="info">取 消</el-button>
        <el-button @click="handleConfirm()" size="small" type="primary">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tables from '../../mixins/table'
import handleBtn from '../../mixins/dialog/handleBtn'
import { ROLE_MANAGE } from '../../libs/api'
import dialogMain from './dialogMain.vue'
import dialogTip from '../../components/dialogTip/index.vue'

export default {
  name: 'roleManage',
  mixins: [tables, handleBtn],
  components: { dialogMain, dialogTip },
  data() {
    return {
      tableLoading: false,
      isRoleManage: true,
      dic: {
        menuId: [],
        initDialogData: {}
      },
      formatForbbidenDic: {
        0: '未禁用',
        1: '禁用'
      },
      searchUrl: ROLE_MANAGE.GET_LIST,
      addUrl: ROLE_MANAGE.ADD_LIST,
      delUrl: ROLE_MANAGE.DEL_LIST,
      editUrl: ROLE_MANAGE.EDIT_LIST,
      delCheckUrl: ROLE_MANAGE.DEL_CHECK,
      forbbidenUrl: ROLE_MANAGE.FOBBIDEN_LIST,
      findRoleId: ROLE_MANAGE.FIND_ROLE_ID
    }
  },
  mounted() {
    this.getALLRoleList() // 获取所有的角色
    this.searchTableData() // table 数据表查询
  },
  methods: {
    searchTableData() {
      this.handleSearch(this.searchUrl)
    },
    formatForbbiden(forbbiden) {
      return this.formatForbbidenDic[forbbiden]
    },
    ifForbidden() {
      const forbbiden = this.selection[0].roleName.split(',')[2]
      // 数据已经禁用
      if (forbbiden === this.FORBIDDEN) {
        return {
          code: 0,
          msg: '该数据已经禁用，不能删除'
        }
      }
      return {
        code: 1,
        msg: ''
      }
    },
    repeatForbbiden(type) { // 禁用的不能再禁用，未禁用的不能再反禁用
      const forbbiden = this.selection[0].roleName.split(',')[2]
      // 禁用的不能再禁用，未禁用的不能反禁用
      const forbiddens = forbbiden === this.FORBIDDEN
      const unforbiddens = forbbiden === this.UNFORBBIDEN

      if (forbiddens && type === 'forbbiden') { // 该条数据已经禁用，不能再禁用
        this.handleNotify('error', '错误', '该条数据已经禁用，不能再禁用,请选择未禁用数据')
        return true
      }
      if (unforbiddens && type === 'unforbbiden') { // 该条数据已经反禁用，不能再反禁用
        this.handleNotify('error', '错误', '该条数据未禁用，不能反禁用，请选择已禁用数据')
        return true
      }
      return false
    },
    // 对返回的结果进行进一步处理
    handleSearchAfter(result) {
      const arrRes = []
      const resultParam = Object.keys(result)
      resultParam.forEach(item => {
        arrRes.push({
          roleName: item,
          menuName: result[item]
        })
      })
      return {
        data: arrRes,
        totalSize: 0, // 隐藏分页
        pageNum: 1,
        pageSize: 0
      }
    },
    handleFormatFormdata(type, dialogFormData) {
      let dialogFormDatas = [...dialogFormData.menuId]
      dialogFormDatas = dialogFormDatas.map(item => {
        const param = {
          roleName: dialogFormData.roleName,
          menuId: item
        }

        if (type === 'edit') {
          param.roleId = dialogFormData.roleNameId
        }
        return param
      })
      return {
        data: dialogFormDatas,
        code: 1
      }
    },
    async handleDelBefore() {
      return new Promise((resolve, reject) => {
        this.$http.post(this.delCheckUrl, { roleId: this.selection[0].roleName.split(',')[1] })
          .then(res => {
            const isAdmin = this.selection[0].roleName.split(',')[0] === 'admin'
            if (res.data.data === 0 && !isAdmin) { // 可以删除
              resolve({
                canDelete: '0',
                msg: ''
              })
            } else if (isAdmin) {
              resolve({
                canDelete: '1',
                msg: '该角色是 admin，不能删除！'
              })
            } else { // 不可删除
              resolve({
                canDelete: '1',
                msg: '该角色正在被使用，不能删除！'
              })
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    initEditFormData() {
      this.dic = {
        ...this.dic,
        initDialogData: this.selection[0]
      }
      // 添加id是角色id
      this.selection = this.selection.map(item => {
        const data = item.roleName.split(',')
        return { ...item, id: data[1], forbidden: data[2] }
      })
    },
    handleDeldata() {
      return {
        roleId: this.selection[0].roleName.split(',')[1]
      }
    },
    formatForbbidenData(type) {
      let forbidden = 0
      if (type === 'forbbiden') {
        forbidden = 1
      }
      return {
        roleId: this.selection[0].roleName.split(',')[1],
        forbidden
      }
    },
    async getALLRoleList() {
      /* eslint-disable */
      return await new Promise((resolve, reject) => {
        this.$http.post(this.findRoleId)
          .then(res => {
            if (res.data.code === 1) {
              this.dic.menuId = res.data.data.map(item => ({
                label: item.menuName,
                value: item.menuId
              }))
            } else {
              this.handleNotify('error', '错误', '获取所有角色列表失败')
            }
            resolve()
          })
          .catch(err => {
            this.handleNotify('error', '错误', err || '获取所有角色列表失败')
            reject()
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
